module.exports = __webpack_public_path__ + "static/media/bezier-curve.9cf4700b.svg";